import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, ImageList, ImageListItem } from '@mui/material';
const DialogFotografias = ({ images, onClose, ...props }) => {
    return (<Dialog {...props}>
      <DialogTitle>Fotografias</DialogTitle>
      <DialogContent>
        <ImageList sx={{ overflowY: images.length > 8 ? 'auto' : 'hidden' }} cols={4} rowHeight={260}>
          {images.map((row, i) => (<ImageListItem sx={{ cursor: 'grab' }} key={`img-${i}${row}`} onClick={() => {
                window.open(`/api/Upload/obler-photos/download/${row}`, '_blank', 'noreferrer');
            }}>
              <img src={`/api/Upload/obler-photos/download/${row}`} loading='lazy'/>
            </ImageListItem>))}
        </ImageList>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={() => onClose()}>
          OK
        </Button>
      </DialogActions>
    </Dialog>);
};
export default DialogFotografias;
